<div class="mx-auto w-full max-w-7xl px-4 py-3 text-xs text-gray-600 dark:text-gray-400 sm:text-sm">
  <div class="flex flex-col items-center gap-2 text-center sm:flex-row sm:flex-wrap sm:justify-between sm:gap-4 sm:text-left">
    <p>{{ 'AllRightsReserved.©2025SuknaCapital' | translate }}</p>

    @if (user$ | async; as user) {
      <p>{{ 'designedAndDevelopedBySuknaCapital' | translate }}</p>
    } @else {
      <div class="flex flex-wrap items-center justify-center gap-3 sm:justify-start">
        <button type="button" class="hover:underline" (click)="openDisclosures()">{{ 'disclosures' | translate }}</button>
        <button type="button" class="hover:underline" (click)="openPrivacyPolicy()">{{ 'privacy&CookiesPolicy' | translate }}</button>
        <button type="button" class="hover:underline" (click)="openContactUs()">{{ 'contactUs' | translate }}</button>
      </div>
    }

    <div class="flex flex-wrap items-center justify-center gap-2 sm:justify-end">
      <p>{{ 'CMALicense24284-02' | translate }}</p>
      <span class="hidden h-4 w-px bg-gray-300 dark:bg-gray-600 sm:inline-block"></span>
      <p>{{ 'CRNo.1010808216' | translate }}</p>
    </div>
  </div>
</div>
